export function isDev() {
  return process.env.REACT_APP_ENV === 'dev';
}

export function hasServiceEnv() {
  return process.env.REACT_APP_SERVICE_ID;
}

export function hasProductEnv() {
  return process.env.REACT_APP_PRODUCT_ID;
}

export const envConfig = {
  REACT_APP_DAYS_TO_ALLOW_RETURNS: process.env.REACT_APP_DAYS_TO_ALLOW_RETURNS,
  REACT_APP_BLOOD_BANK_SERVICE_ID: process.env.REACT_APP_BLOOD_BANK_SERVICE_ID,
  REACT_APP_BLOOD_BLANK_UNIT_MORUMBI: process.env.REACT_APP_BLOOD_BLANK_UNIT_MORUMBI,
  REACT_APP_BLOOD_BLANK_UNIT_MORUMBI_MACRO: process.env.REACT_APP_BLOOD_BLANK_UNIT_MORUMBI_MACRO,
  REACT_APP_BLOOD_BLANK_UNIT_MORUMBI_RESOURCEID: process.env.REACT_APP_BLOOD_BLANK_UNIT_MORUMBI_RESOURCEID,
  REACT_APP_BLOOD_BLANK_UNIT_PEPSICO: process.env.REACT_APP_BLOOD_BLANK_UNIT_PEPSICO,
  REACT_APP_BLOOD_BLANK_UNIT_PEPSICO_MACRO: process.env.REACT_APP_BLOOD_BLANK_UNIT_PEPSICO_MACRO,
  REACT_APP_BLOOD_BLANK_UNIT_PEPSICO_RESOURCEID: process.env.REACT_APP_BLOOD_BLANK_UNIT_PEPSICO_RESOURCEID,
  REACT_APP_X_APP_NAME: process.env.REACT_APP_X_APP_NAME,
  REACT_APP_CARE_PLUS_FIRST_APPOINTMENT_SPECIALTY: process.env.REACT_APP_CARE_PLUS_FIRST_APPOINTMENT_SPECIALTY,
  REACT_APP_CARE_PLUS_TYPE_GROUP_UNITS: process.env.REACT_APP_CARE_PLUS_TYPE_GROUP_UNITS,
  REACT_APP_BUSINESS_RULE: process.env.REACT_APP_BUSINESS_RULE,
  REACT_APP_UPLOAD_BASE_URL_API: process.env.REACT_APP_UPLOAD_BASE_URL_API,
  REACT_APP_BLOOD_BLANK_UNIT_WPP: process.env.REACT_APP_BLOOD_BLANK_UNIT_WPP,
  REACT_APP_BLOOD_BLANK_UNIT_WPP_MACRO: process.env.REACT_APP_BLOOD_BLANK_UNIT_WPP_MACRO,
  REACT_APP_BLOOD_BLANK_UNIT_WPP_RESOURCEID: process.env.REACT_APP_BLOOD_BLANK_UNIT_WPP_RESOURCEID,
  REACT_APP_BLOOD_BLANK_UNIT_CTI: process.env.REACT_APP_BLOOD_BLANK_UNIT_CTI,
  REACT_APP_BLOOD_BLANK_UNIT_CTI_MACRO: process.env.REACT_APP_BLOOD_BLANK_UNIT_CTI_MACRO,
  REACT_APP_BLOOD_BLANK_UNIT_CTI_RESOURCEID: process.env.REACT_APP_BLOOD_BLANK_UNIT_CTI_RESOURCEID,
  REACT_APP_CARE_PLUS_SPECIALTIES_SCHEDULING_FROM_TWO_DAYS:
    process.env.REACT_APP_CARE_PLUS_SPECIALTIES_SCHEDULING_FROM_TWO_DAYS,
  REACT_APP_CARE_PLUS_CONSULT_KIND: process.env.REACT_APP_CARE_PLUS_CONSULT_KIND,
  REACT_APP_SERVICE_ID: process.env.REACT_APP_SERVICE_ID,
  REACT_CALL_CENTER_WHATSAPP_CONTACT: process.env.REACT_CALL_CENTER_WHATSAPP_CONTACT
};
